module.exports = __webpack_public_path__ + "img/digitalOnnuri_3.5c1c44a2.png";